import Flickyity from 'flickity';

export default {
    init() {
        const slider = document.querySelectorAll('[data-contained-slider]');

        slider.forEach(slides => {
            const flickity = new Flickyity(slides, {
                groupCells: '100%',
                imagesLoaded: true
            });
        });
    }
};
